import styled from "styled-components";
import { FlexColumn, FlexRow } from "styles/layout";

export const EmptyMatchContainer = styled(FlexColumn)`
  padding: 2px;
  width: 200px;
  height: 60px;
`;

export const MatchContainer = styled(FlexColumn)`
  &:hover {
    background: #f0f0f0;
  }
`;

export const MatchTeamContainer = styled(FlexRow)`
  padding: 2px;
  border: 1px solid black;
  width: 200px;
  height: 30px;

  &:last-child {
    border-top: 0px;
  }
`;

export const LogoContainer = styled.div`
  width: 24px;
  height: 24px;
  padding-right: 4px;
`;

const BoldIfWonText = styled("span")<{
  hasWinner: boolean;
  isWinner: boolean;
}>`
  ${({ isWinner, hasWinner }) => hasWinner && !isWinner && "color: Gray"}
  ${({ isWinner, hasWinner }) => hasWinner && isWinner && "font-weight: bold"}
`;

export const TeamName = styled(BoldIfWonText)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
`;

export const SourceTitle = styled.span`
  font-size: 11pt;
  color: gray;
  font-style: italic;
`;

export const TeamScore = styled(BoldIfWonText)`
  margin-left: auto;
  margin-right: 4px;
  text-align: center;
  width: 16px;
`;

export const ResetIdentifier = styled(FlexColumn)`
  text-align: center;
  background: gainsboro;
  border: 1px solid darkgray;
  font-size: 10pt;
  border-top: none;
  font-style: italic;
  color: gray;
  padding: 2px 0;
`;
